export default {
  bind(el, bindings, vnode) {
    let menu = el.querySelector('.js-menu')
    let toggler = el.querySelector('.js-toggle-menu')
    let link = el.querySelectorAll('.js-link')
    let header = el.querySelector('.js-header')
    let offset = el.querySelector('.js-offset')
    let content = el.querySelector('.js-content')

    document.onscroll = () => {
      header.classList.add('small-header' )
      menu.classList.remove('active')
      offset.classList.add('active')
      content.classList.add('is-active')
      if(window.pageYOffset == 0) {
        header.classList.remove('small-header')
        menu.classList.add('active')
        offset.classList.remove('active')
        content.classList.add('is-active')

      }
      
    }

    toggler.onclick = () => {
      menu.classList.toggle('is-active')
      toggler.classList.toggle('is-active')
    }
    
    link.forEach(el => {
      el.onclick = () => {
        setTimeout(() => {
          menu.classList.remove('is-active')
          toggler.classList.remove('is-active')

        }, 200)
      }
    })

    
    let links = el.querySelectorAll('.js-link-desktop')
    let section = el.querySelectorAll('.js-section')
    console.log(section)

    const imageObserver = new IntersectionObserver((entries, imgObserver) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.log(entry)
          links.forEach(el => {
            console.log(el.children)
            let item = '#' + entry.target.id
            el.classList.remove('is-active')
            console.log(item, el.children[0].hash)
            if (item == el.children[0].hash) {
              console.log(1)
              el.classList.add('is-active')
            }
          })
        }
      })
    })

    section.forEach((v) => {
      imageObserver.observe(v)
    })
    


  }
}



// WEBPACK FOOTER //
// ./src/js/directives/header/header.js